import { useState, useRef, useEffect } from "react";
import data from "../../utils/constants/data.json";
import details from "../../utils/constants/details.json";
import useGeminiAi from "../../utils/custom-hooks/useGeminiAi";

const AiComponent = () => {
    const [summarizedResponse, setSummarizedResponse] = useState(null);
    const [loader, setLoader] = useState(0);

    let btn = useRef("Go");

    const dataForSummary = structuredClone(data);
    delete dataForSummary.feedData;

    const geminiSummarize = async () => {
        const response = await useGeminiAi({
            text:
                "Summarize the given text concisely in 20 to 50 words. Focus on key points and avoid unnecessary details and characters. Ensure each summary is unique and not repetitive across multiple runs. Don't provide multiple summaries and don't include any headings/sub-headings. Input data: " +
                JSON.stringify(dataForSummary),

            image: null,
        });

        //console.log(response);

        const backupSummary =
            "Hari is a Frontend Engineer with over five years of experience in software engineering, currently at Chargebee, a leading subscription management company. With expertise in JavaScript, React, Redux, and other technologies, he has contributed to impactful projects, including implementing AWS Pinpoint for Worldline and optimizing memory usage at Chargebee. In addition to his technical work, Hari enjoys sharing his knowledge through blogging, with articles focused on React, JavaScript, and software engineering best practices.";

        btn.current = "Try Again";

        if (response.responseReceived) {
            setSummarizedResponse(response.responseData);
        } else {
            setSummarizedResponse(loader + "-" + backupSummary);
        }
    };

    useEffect(() => {
        if (loader !== 0) {
            geminiSummarize();
        }
    }, [loader]);

    return (
        <div className="card-component" id="focus-point">
            <div className="summarize-profile">
                <img src={details["gemini-ai-logo"]} alt="ai-summarize" />

                <p className="summarize-descriptions">Summarize Portfolio.</p>

                {/* <p className="summarize-descriptions--subtext">- By Google Gemini.</p> */}

                <div>
                    <button
                        className="summarize-btn"
                        onClick={() => {
                            btn.current = "Summarizing...";
                            setLoader(loader + 1);
                        }}
                        disabled={btn.current === "Summarizing..."}>
                        {btn.current}
                    </button>

                    {summarizedResponse && (
                        <button
                            className="summarize-btn"
                            onClick={() => {
                                btn.current = "Go";
                                setSummarizedResponse(null);
                            }}
                            disabled={btn.current === "Summarizing..."}
                            style={btn.current === "Summarizing..." ? { opacity: 0.5 } : { opacity: 1 }}>
                            Close
                        </button>
                    )}
                </div>

                {summarizedResponse && (
                    <div>
                        <p className="summarize-response--descriptions">{summarizedResponse}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AiComponent;
